"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _primitives = require("./primitives");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ButtonGroupOption = function ButtonGroupOption(_ref) {
  var id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      checked = _ref.checked,
      disabled = _ref.disabled,
      size = _ref.size,
      totalOptions = _ref.totalOptions,
      onChange = _ref.onChange,
      variant = _ref.variant;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      clicked = _useState2[0],
      setClicked = _useState2[1];

  var handleLabelClick = function handleLabelClick() {
    setClicked(true);
  };

  var handleInputFocus = function handleInputFocus(event) {
    if (clicked) {
      setClicked(false);
      event.target.blur();
    }
  };

  var handleChange = function handleChange(event) {
    if (!disabled) {
      onChange(event.target.value);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_primitives.HiddenInput, {
    type: "radio",
    id: id,
    name: name,
    value: value,
    checked: checked,
    onChange: handleChange,
    onFocus: handleInputFocus,
    disabled: disabled,
    variant: variant
  }), /*#__PURE__*/_react["default"].createElement(_primitives.ButtonLabel, {
    htmlFor: id,
    name: name,
    onClick: handleLabelClick,
    size: size,
    totalOptions: totalOptions,
    value: value,
    variant: variant
  }, label));
};

ButtonGroupOption.propTypes = {
  id: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].node.isRequired,
  value: _propTypes["default"].string.isRequired,
  checked: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
  totalOptions: _propTypes["default"].number.isRequired,
  variant: _propTypes["default"].string
};
ButtonGroupOption.defaultProps = {
  checked: false,
  disabled: false,
  size: 'base',
  variant: 'default'
};
var _default = ButtonGroupOption;
exports["default"] = _default;